module.exports = __webpack_public_path__ + "static/media/cjmls-white.e6e27d3e.png";